var locale = {
  placeholder: 'Выберите время',
  rangePlaceholder: ['Время начала', 'Время окончания']
};
export default locale;